<template>
  <div class="form-container">
    <form @submit.prevent="formData.id ? updateUsers() : addUser()" class="user-form">
      <!-- Alert Section -->
      <div class="row mb-3" v-if="alertTable.state">
        <div class="col-12">
          <soft-alert color="danger" class="alert-custom">
            <i class="fas fa-exclamation-triangle me-2"></i>
            {{ alertTable.message }}
          </soft-alert>
        </div>
      </div>

      <!-- Personal Information Section -->
      <div class="form-section">
        <h5 class="section-title">
          <i class="fas fa-user text-primary me-2"></i>
          Información Personal
        </h5>

        <div class="row g-3">
          <!-- Gender Selection -->
          <div class="col-12">
            <label class="form-label fw-semibold">
              <i class="fas fa-venus-mars text-info me-2"></i>
              Género <span class="text-danger">*</span>
            </label>
            <div class="gender-options">
              <div
                v-for="gen in genres"
                :key="gen.id"
                class="form-check form-check-inline gender-check"
              >
                <input
                  class="form-check-input"
                  type="radio"
                  :name="`gender-${gen.id}`"
                  :id="`gender-${gen.id}`"
                  @click="formData.userdata.genero = gen.id"
                  :checked="getStatusgenre(gen.id)"
                >
                <label class="form-check-label" :for="`gender-${gen.id}`">
                  {{ gen.name }}
                </label>
              </div>
            </div>
          </div>

          <!-- Full Name -->
          <div class="col-12">
            <label for="name" class="form-label fw-semibold">
              <i class="fas fa-signature text-success me-2"></i>
              Nombre Completo <span class="text-danger">*</span>
            </label>
            <soft-input
              id="name"
              v-model:value="formData.userdata.primer_nombre"
              type="text"
              placeholder="Ingrese el nombre completo"
              aria-label="Nombre completo"
              class="form-input"
            />
          </div>
        </div>
      </div>

      <!-- System Information Section -->
      <div class="form-section">
        <h5 class="section-title">
          <i class="fas fa-cogs text-warning me-2"></i>
          Información del Sistema
        </h5>

        <div class="row g-3">
          <!-- Role Selection -->
          <div class="col-md-6">
            <label for="role" class="form-label fw-semibold">
              <i class="fas fa-user-tag text-warning me-2"></i>
              Rol de Usuario <span class="text-danger">*</span>
            </label>
            <select class="form-select custom-select" id="role" v-model="formData.roles_users">
              <option value="" disabled>Selecciona un rol</option>
              <option
                v-for="rol in roles"
                :key="rol.id"
                :value="rol.id"
                @click="getSelectedRole(rol)"
              >
                {{ rol.nombre }}
              </option>
            </select>
          </div>

          <!-- Membership Selection -->
          <div class="col-md-6">
            <label for="payment_plan_users" class="form-label fw-semibold">
              <i class="fas fa-crown text-success me-2"></i>
              Membresía <span class="text-danger">*</span>
            </label>
            <select class="form-select custom-select" id="payment_plan_users" v-model="formData.payment_plan_users">
              <option value="" disabled>Selecciona una membresía</option>
              <option
                v-for="mem in memberships_plans"
                :key="mem.id"
                :value="mem.id"
              >
                {{ mem.code }}
              </option>
            </select>
          </div>
        </div>
      </div>

      <!-- Identification Section -->
      <div class="form-section">
        <h5 class="section-title">
          <i class="fas fa-id-card text-info me-2"></i>
          Identificación
        </h5>

        <div class="row g-3">
          <!-- Document Type -->
          <div class="col-md-6">
            <label for="docType" class="form-label fw-semibold">
              <i class="fas fa-passport text-info me-2"></i>
              Tipo de Identificación <span class="text-danger">*</span>
            </label>
            <select class="form-select custom-select" id="docType" v-model="formData.userdata.tipo_identificacion">
              <option value="" disabled>Selecciona un tipo</option>
              <option
                v-for="docType in documentType"
                :key="docType.id"
                :value="docType.id"
              >
                {{ docType.name }}
              </option>
            </select>
          </div>

          <!-- Document Number -->
          <div class="col-md-6">
            <label for="document" class="form-label fw-semibold">
              <i class="fas fa-hashtag text-info me-2"></i>
              Número de Identificación <span class="text-danger">*</span>
            </label>
            <soft-input
              id="document"
              v-model:value="formData.userdata.cedula_persona"
              type="text"
              placeholder="Número de identificación"
              aria-label="Número de identificación"
              class="form-input"
            />
          </div>
        </div>
      </div>

      <!-- Contact Information Section -->
      <div class="form-section">
        <h5 class="section-title">
          <i class="fas fa-address-book text-primary me-2"></i>
          Información de Contacto
        </h5>

        <div class="row g-3">
          <!-- Email -->
          <div class="col-md-6">
            <label for="email" class="form-label fw-semibold">
              <i class="fas fa-envelope text-primary me-2"></i>
              Correo Electrónico <span class="text-danger">*</span>
            </label>
            <soft-input
              id="email"
              v-model:value="formData.email"
              type="email"
              placeholder="correo@ejemplo.com"
              aria-label="Correo electrónico"
              class="form-input"
            />
          </div>

          <!-- Mobile Phone -->
          <div class="col-md-6">
            <label for="celular" class="form-label fw-semibold">
              <i class="fas fa-mobile-alt text-success me-2"></i>
              Teléfono Móvil <span class="text-danger">*</span>
            </label>
            <soft-input
              id="celular"
              v-model:value="formData.userdata.celular_movil"
              type="tel"
              placeholder="+57 300 123 4567"
              aria-label="Teléfono móvil"
              class="form-input"
            />
          </div>

          <!-- WhatsApp -->
          <div class="col-md-6">
            <label for="whatsapp" class="form-label fw-semibold">
              <i class="fab fa-whatsapp text-success me-2"></i>
              WhatsApp
            </label>
            <soft-input
              id="whatsapp"
              v-model:value="formData.userdata.celular_whatsapp"
              type="tel"
              placeholder="+57 300 123 4567"
              aria-label="WhatsApp"
              class="form-input"
            />
          </div>

          <!-- Address -->
          <div class="col-md-6">
            <label for="direccion" class="form-label fw-semibold">
              <i class="fas fa-map-marker-alt text-danger me-2"></i>
              Dirección
            </label>
            <soft-input
              id="direccion"
              v-model:value="formData.userdata.direccion_persona"
              type="text"
              placeholder="Dirección completa"
              aria-label="Dirección"
              class="form-input"
            />
          </div>
        </div>
      </div>

      <!-- Location Section -->
      <div class="form-section">
        <h5 class="section-title">
          <i class="fas fa-globe text-info me-2"></i>
          Ubicación
        </h5>

        <div class="row g-3">
          <!-- Country -->
          <div class="col-12">
            <label class="form-label fw-semibold">
              <i class="fas fa-flag text-info me-2"></i>
              País <span class="text-danger">*</span>
            </label>
            <soft-select
              :selectedValue="formData.userdata.id_pais"
              :options="countries"
              @selectedValue="selected.selectedCountry"
              @callbackEvent="getStates"
              placeholder="Selecciona un país"
              class="custom-soft-select"
            />
          </div>

          <!-- State/Department -->
          <div class="col-md-6">
            <label class="form-label fw-semibold">
              <i class="fas fa-map text-warning me-2"></i>
              Departamento/Estado
            </label>
            <soft-select
              :selectedValue="formData.userdata.id_estado"
              @selectedValue="selected.selectedState"
              :options="states"
              @callbackEvent="getCities"
              placeholder="Selecciona un departamento"
              class="custom-soft-select"
            />
          </div>

          <!-- City -->
          <div class="col-md-6">
            <label class="form-label fw-semibold">
              <i class="fas fa-city text-success me-2"></i>
              Ciudad
            </label>
            <soft-select
              :selectedValue="formData.userdata.id_ciudad"
              @selectedValue="selected.selectedCity"
              :options="cities"
              placeholder="Selecciona una ciudad"
              class="custom-soft-select"
            />
          </div>
        </div>
      </div>

      <!-- Submit Section -->
      <div class="submit-section">
        <div class="d-flex gap-3 justify-content-center">
          <soft-button
            type="button"
            color="secondary"
            variant="outline"
            class="btn-action"
          >
            <i class="fas fa-times me-2"></i>
            Cancelar
          </soft-button>

          <soft-button
            type="submit"
            :disabled="isLoading"
            :color="formData.id ? 'warning' : 'success'"
            variant="gradient"
            class="btn-action btn-primary-action"
          >
            <span v-if="isLoading">
              <i class="fas fa-spinner fa-spin me-2"></i>
              {{ formData.id ? 'Actualizando...' : 'Registrando...' }}
            </span>
            <span v-else>
              <i :class="formData.id ? 'fas fa-save me-2' : 'fas fa-user-plus me-2'"></i>
              {{ formData.id ? 'Actualizar Usuario' : 'Registrar Usuario' }}
            </span>
          </soft-button>
        </div>
      </div>
    </form>
  </div>
</template>

<style lang="scss" scoped>
.form-container {
  padding: 0.1rem;
  background: linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%);
  border-radius: 1rem;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
  max-height: 80vh;
  overflow-y: auto;
}

.user-form {
  .alert-custom {
    border-radius: 0.75rem;
    border: none;
    box-shadow: 0 4px 12px rgba(220, 53, 69, 0.15);
  }
}

.form-section {
  background: white;
  border-radius: 0.75rem;
  padding: 1.5rem;
  margin-bottom: 1.5rem;
  border: 1px solid #e9ecef;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  transition: all 0.3s ease;

  &:hover {
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
    transform: translateY(-2px);
  }

  .section-title {
    color: #495057;
    font-weight: 600;
    margin-bottom: 1.25rem;
    padding-bottom: 0.75rem;
    border-bottom: 2px solid #e9ecef;

    i {
      font-size: 1.1rem;
    }
  }
}

.form-label {
  margin-bottom: 0.5rem;
  color: #495057;
  font-size: 0.9rem;

  i {
    font-size: 0.85rem;
  }

  .text-danger {
    font-weight: bold;
  }
}

.gender-options {
  background: #f8f9fa;
  border-radius: 0.5rem;
  padding: 1rem;
  border: 1px solid #e9ecef;

  .gender-check {
    margin-right: 1.5rem;

    .form-check-input {
      margin-top: 0.3rem;

      &:checked {
        background-color: #007bff;
        border-color: #007bff;
      }
    }

    .form-check-label {
      margin-left: 0.5rem;
      font-weight: 500;
      color: #495057;
    }
  }
}

.form-input {
  transition: all 0.2s ease-in-out;

  &:focus-within {
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(0, 123, 255, 0.15);
  }
}

.custom-select {
  border: 1px solid #ced4da;
  border-radius: 0.5rem;
  padding: 0.75rem;
  font-size: 0.9rem;
  transition: all 0.2s ease-in-out;
  background: white;

  &:focus {
    border-color: #007bff;
    box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
    outline: none;
  }

  &:hover {
    border-color: #adb5bd;
  }
}

.custom-soft-select {
  ::v-deep .soft-select-wrapper {
    .selected-option {
      border: 1px solid #ced4da;
      border-radius: 0.5rem;
      padding: 0.75rem;
      transition: all 0.2s ease-in-out;

      &:hover {
        border-color: #adb5bd;
      }

      &:focus {
        border-color: #007bff;
        box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
      }
    }
  }
}

.submit-section {
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  border-radius: 0.75rem;
  padding: 2rem;
  text-align: center;
  border: 1px solid #e9ecef;

  .btn-action {
    padding: 0.75rem 2rem;
    border-radius: 0.5rem;
    font-weight: 600;
    transition: all 0.2s ease-in-out;
    min-width: 150px;

    &:hover {
      transform: translateY(-2px);
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    }

    &.btn-primary-action {
      box-shadow: 0 4px 12px rgba(0, 123, 255, 0.3);
    }

    &:disabled {
      opacity: 0.6;
      transform: none;
      box-shadow: none;
    }
  }
}

// Responsive Design
@media (max-width: 768px) {
  .form-container {
    padding: 1rem;
    max-height: 90vh;
  }

  .form-section {
    padding: 1rem;
    margin-bottom: 1rem;
  }

  .submit-section {
    padding: 1.5rem;

    .d-flex {
      flex-direction: column;
      gap: 1rem !important;
    }

    .btn-action {
      width: 100%;
      min-width: auto;
    }
  }

  .gender-options {
    .gender-check {
      display: block;
      margin-bottom: 0.5rem;
      margin-right: 0;
    }
  }
}

// Scrollbar styling
.form-container {
  scrollbar-width: thin;
  scrollbar-color: #6c757d #f8f9fa;

  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-track {
    background: #f8f9fa;
    border-radius: 3px;
  }

  &::-webkit-scrollbar-thumb {
    background: #6c757d;
    border-radius: 3px;

    &:hover {
      background: #495057;
    }
  }
}

// Animation
@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.form-section {
  animation: fadeInUp 0.3s ease-out;

  &:nth-child(2) { animation-delay: 0.1s; }
  &:nth-child(3) { animation-delay: 0.2s; }
  &:nth-child(4) { animation-delay: 0.3s; }
  &:nth-child(5) { animation-delay: 0.4s; }
  &:nth-child(6) { animation-delay: 0.5s; }
}
</style>

<script>
import SoftInput from "@/components/SoftInput.vue";
import { ref } from "vue";
import SoftButton from "@/components/SoftButton.vue";
import SoftAlert from "@/components/SoftAlert.vue";

import SoftSelect from "@/components/SoftSelect.vue";
import { useMembership } from "../useMembership.js";
import { useStore } from 'vuex';

export default {
    emits: ['close'],
    props: {
        userdata: Object,
        mode: String
    },
    components: {
        SoftInput,
        SoftButton,
        SoftSelect,
        SoftAlert
    },
    setup(props, { emit }) {
        const formData = ref({
            id: null,
            email: null,
            roles_users: null,
            payment_plan_users: null,
            userdata: {
                genero: null,
                primer_nombre: null,
                celular_movil: null,
                celular_whatsapp: null,
                direccion_persona: null,
                tipo_identificacion: null,
                cedula_persona: null,
                id_pais: null,
                id_estado: null,
                id_ciudad: null,
            }
        });

        const store = useStore();

        const { isLoading, genres,
            countries,
            states,
            cities,
            getCities,
            getStates,
            roles,
            documentType,
            memberships_plans,
            alertTable } = useMembership()

        const selected = ref({
            selectedCountry: (data) => {
                formData.value.userdata.id_pais = data
            },
            selectedState: (data) => {
                formData.value.userdata.id_estado = data
            },
            selectedCity: (data) => {
                formData.value.userdata.id_ciudad = data
            },

        })



        if (props.userdata) {
            const userdata = JSON.parse(JSON.stringify(props.userdata))

            for (const [clave, valor] of Object.entries(userdata)) {
                if (clave in formData.value) {

                    if (clave === 'userdata') {
                        if (userdata.userdata) {
                            for (const [clave1, valor1] of Object.entries(userdata.userdata)) {
                                if (clave1 in formData.value.userdata) {
                                    let valorU = valor1
                                    if (clave1 === "genero") {
                                        valorU = parseInt(valor1)
                                    }

                                    formData.value.userdata[clave1] = valorU

                                }
                            }
                        }
                    }

                    if (clave === "roles_users") {
                        if (valor) {
                            formData.value.roles_users = valor.role.id
                        }

                    }

                    if (clave === 'payment_plan_users') {
                        if (valor) {
                            formData.value.payment_plan_users = valor.p_plans
                        }
                    }

                    if (clave === 'email') {
                        formData.value[clave] = valor
                    }
                    if (clave === 'id') {
                        formData.value[clave] = valor
                    }
                }
            }

        }


        const validLocalidate = () => {
            if (props.userdata) {
                const json = JSON.parse(JSON.stringify(props.userdata))
                const userdata = json.userdata;
                if (userdata)
                    if (userdata.id_pais)
                        if (!userdata.id_estado) {
                            getStates(userdata.id_pais)
                        } else {
                            if (!json.id_ciudad)
                                if (userdata.id_estado) {
                                    getCities(userdata.id_estado)
                                }
                        }

            } else {
                delete formData.value.id
            }
        }

        validLocalidate();

        const apiUsers = async (path) => {
            isLoading.value = true
            await store.dispatch(path, formData.value).then((res) => {
                isLoading.value = false;
                emit('close', res)
            }).catch((error) => {
                isLoading.value = false;
                alertTable.value.state = true,
                    alertTable.value.message = error
            });
        }


        const addUser = () => {
            apiUsers('appMembership/storeUsers')
        }
        const updateUsers = () => {
            apiUsers('appMembership/updateUsers')
        };


        const getStatusgenre = (genre) => {
            let gen = formData.value.userdata.genero;
            if (gen) {
                if (gen === genre) {
                    return true
                } else {
                    return false
                }
            } else {
                return false
            }
        }

        const getSelectedRole = (role) => {
            if (role.id === formData.value.roles_users) {
                return true
            } else {
                return false
            }
        }


        return {
            countries, states, cities, genres, getCities, updateUsers, getSelectedRole, memberships_plans,
            getStates, getStatusgenre, documentType, formData, roles, isLoading, selected, addUser, alertTable
        }
    }
};
</script>
<style scoped></style>
